module.exports = __webpack_public_path__ + "img/battle_section3_item2.0b2fd3a3.png";